import { API, InlineTool } from '@editorjs/editorjs'
import { paths } from '@routes/header-paths'

export const HASHTAG_CLASS_NAME = 'cdx-hashtag'
export const HASHTAG_TAG_NAME = 'SPAN'

class Hashtag implements InlineTool {
  static get isInline() {
    return true
  }

  static get sanitize() {
    return {
      [HASHTAG_TAG_NAME.toLowerCase()]: {
        'data-href': true,
        class: HASHTAG_CLASS_NAME,
      },
    }
  }

  get shortcut() {
    return 'CMD+SHIFT+A'
  }

  private _isApplied: boolean
  private button: HTMLButtonElement
  private api: API

  get isApplied() {
    return this._isApplied
  }

  set isApplied(isApplied) {
    this._isApplied = isApplied

    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, isApplied)
  }

  constructor({ api }) {
    this.api = api
    this.button = null
    this._isApplied = false
  }

  render() {
    this.button = document.createElement('button')
    this.button.type = 'button'
    this.button.textContent = '#'
    this.button.classList.add(this.api.styles.inlineToolButton)

    return this.button
  }

  surround(range: Range) {
    if (this.isApplied) {
      this.unwrap(range)
      return
    }

    this.wrap(range)
  }

  wrap(range: Range) {
    const textContent = range.toString()

    if (textContent.includes(' ')) {
      return window.alert(this.api.i18n.t('wrapWithSpaceWarning'))
    }

    const selectedText = range.extractContents()
    const tag = document.createElement(HASHTAG_TAG_NAME)

    tag.classList.add(HASHTAG_CLASS_NAME)
    tag.setAttribute(
      'data-href',
      [paths.search, window.encodeURIComponent(`#${textContent}`)].join('/'),
    )
    if (!textContent.match(/#|\uFF03/u)) {
      tag.appendChild(document.createTextNode('#'))
    }
    tag.appendChild(selectedText)

    /**
     * - 用 DocumentFragment.appendChild 比多個 range.insertNode 好閱讀
     * - \u200B (Zero width space) 用來區隔 #hashtag
     */
    const result = document.createDocumentFragment()
    const before = document.createTextNode('\u200B')
    const after = document.createTextNode('\u200B')
    result.appendChild(before)
    result.appendChild(tag)
    result.appendChild(after)
    range.insertNode(result)

    // 把游標移動到空格之後
    window.getSelection().collapse(after, 1)
  }

  unwrap(range: Range) {
    const textContent = range.toString()

    if (textContent.includes(' ')) {
      return window.alert(this.api.i18n.t('unwrapWithSpaceWarning'))
    }

    const tag = this.api.selection.findParentTag(HASHTAG_TAG_NAME, HASHTAG_CLASS_NAME)
    const text = document.createTextNode(textContent.replace('#', ''))

    tag.remove()
    range.insertNode(text)
  }

  checkState(_: Selection) {
    const target = this.api.selection.findParentTag(HASHTAG_TAG_NAME, HASHTAG_CLASS_NAME)
    this.isApplied = !!target
    return this.isApplied
  }
}

export default Hashtag
